module.exports = __webpack_public_path__ + "static/media/pic1.598eabc5.jpg";